import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { ArrowLeft, PaperPlaneRight } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await forgotPassword(email);
    setLoading(false);
    if (res.ok) {
      setSent(true);
      toast.success("Password reset link sent!");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="h-10 w-10 rounded-xl flex items-center justify-center font-black text-white"
               style={{ background: "var(--primary)", border: "1.5px solid var(--ink)", boxShadow: "2px 2px 0 0 var(--ink)" }}>
            RA
          </div>
          <span className="display font-black text-2xl">Rating Ally</span>
        </Link>

        <div className="card-pop p-7 sm:p-9">
          <h1 className="display text-3xl font-black tracking-tighter">Reset password</h1>
          <p className="text-sm text-[var(--ink-muted)] mt-1">
            Enter your email and we'll send you a link to reset your password.
          </p>

          {sent ? (
            <div className="mt-7 text-center">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-50 text-emerald-600 mb-4">
                <PaperPlaneRight size={32} weight="bold" />
              </div>
              <p className="text-[var(--ink)] font-medium">Check your inbox!</p>
              <p className="text-sm text-[var(--ink-muted)] mt-1">
                We've sent a password reset link to <strong>{email}</strong>.
              </p>
              <Link to="/login" className="btn-secondary w-full justify-center mt-6 inline-flex">
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-7 space-y-4">
              <div>
                <label className="text-xs font-bold uppercase tracking-widest text-[var(--ink-muted)]">Email</label>
                <input
                  type="email"
                  required
                  className="input-pop mt-1.5"
                  placeholder="you@cafe.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button disabled={loading} type="submit" className="btn-primary w-full justify-center mt-2">
                {loading ? "Sending…" : (<>Send reset link <PaperPlaneRight size={16} weight="bold" /></>)}
              </button>
              <div className="text-center">
                <Link to="/login" className="text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] inline-flex items-center gap-1">
                  <ArrowLeft size={14} /> Back to sign in
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}